import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import { Link } from 'features/i18n/router'
import { ROUTE_PATH } from 'lib/paths'
import { useGetCommunityCampaignGroupsUserLeaderboardQuery } from 'store/api/yay/communityCampaign'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

const GroupInCircleRankingModal = ({ location, groupId }) => {
  const { t } = useTranslation()

  const userLeaderboardRes = useGetCommunityCampaignGroupsUserLeaderboardQuery({
    groupId,
  })

  return (
    <div className="GroupInCircleRankingModal Modal__wrapper">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={location.pathname} />

        <h2 className="Modal__header__h2">{t('group_page.ranking.title')}</h2>
      </div>

      <div className="Modal__body">
        {!userLeaderboardRes?.isFetching &&
        (userLeaderboardRes?.data?.user_leaderboard?.length ?? 0) == 0 ? (
          <div className="RelatedGroupsModal__empty">
            <p>{t('common.no_result')}</p>
          </div>
        ) : (
          <dl className="GroupInCircleRankingModal__dl">
            {userLeaderboardRes?.data?.user_leaderboard?.map?.((x, i) => (
              <Link
                className="GroupInCircleRankingModal__dl__item"
                key={i}
                to={ROUTE_PATH.USER(x?.user?.id)}
              >
                <span className="GroupInCircleRankingModal__dl__item__span">
                  {x?.ranking}
                </span>

                <div className="GroupInCircleRankingModal__dl__item__image">
                  <ImageLoader
                    url={x?.user?.profile_icon_thumbnail}
                    className="GroupInCircleRankingModal__dl__item__image__img"
                  />
                </div>

                <dt className="GroupInCircleRankingModal__dl__item__dt">
                  {x?.user?.nickname}
                </dt>

                <div className="GroupInCircleRankingModal__dl__item__gifts">
                  {x?.top_gifts?.map?.((y, j) => (
                    <div
                      className="GroupInCircleRankingModal__dl__item__gifts__image"
                      key={j}
                    >
                      <ImageLoader
                        url={y || '/images/unknown-gift.png'}
                        className={cx(
                          'GroupInCircleRankingModal__dl__item__gifts__image__img',
                          {
                            'GroupInCircleRankingModal__dl__item__gifts__image__img--anonymous':
                              !y,
                          }
                        )}
                      />
                    </div>
                  ))}
                </div>
              </Link>
            ))}
          </dl>
        )}
      </div>
    </div>
  )
}

export default GroupInCircleRankingModal
